import { IMAGES_ASSETS_URL } from "../constants/links";
import { CreditCardBrands } from "../constants/cardBrands";

const getImagePath = (path) => `${IMAGES_ASSETS_URL}${path}`;

export const getCardImagePath = (cardBrand, cardBrandType, isB2B) => {
  if (isB2B) {
    switch (cardBrand) {
      case CreditCardBrands.PROP:
        return getImagePath("/credit-card-pro-purchase.png");
      case CreditCardBrands.PROX:
        return getImagePath("/credit-card-prox.png");
      case CreditCardBrands.HDCOM:
        return cardBrandType === "HR"
          ? getImagePath("/credit-card-commercial-revolving.png")
          : getImagePath("/credit-card-prox.png");
      default:
    }
  }
  switch (cardBrand) {
    case CreditCardBrands.VISA:
      return getImagePath("/credit-card-visa.png");
    case CreditCardBrands.MA:
      return getImagePath("/credit-card-mastercard.png");
    case CreditCardBrands.AMEX:
      return getImagePath("/credit-card-amex.png");
    case CreditCardBrands.DISC:
      return getImagePath("/credit-card-discover.png");
    case CreditCardBrands.HDCOM:
      return getImagePath("/credit-card-prox.png");
    case CreditCardBrands.HDCON:
      return getImagePath("/credit-card-hd-consumer.png");
    default:
      return "";
  }
};
